<template>
  <section className="cont__contact">
    <p>Let's create something new</p>
    <h3>LET'S GET IN <em>TOUCH</em></h3>
    <a href="mailto:kde66034@gmail.com">Contact Me</a>
  </section>
</template>
